import { render, staticRenderFns } from "./FilterModule.vue?vue&type=template&id=23d21612&scoped=true"
import script from "./FilterModule.vue?vue&type=script&lang=js"
export * from "./FilterModule.vue?vue&type=script&lang=js"
import style0 from "./FilterModule.vue?vue&type=style&index=0&id=23d21612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d21612",
  null
  
)

export default component.exports